import { buttonUnstyledClasses, tabUnstyledClasses } from '@mui/base'
import StylesTabServiceInterface from '~/src/components/mui-wrappers/styled/tab/styles/StylesTabServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesTabServiceStyleTwo extends TemplateServiceStyleBase implements StylesTabServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {
      color: '#fff',
      cursor: 'pointer',
      minWidth: '145px',
      fontSize: '0.875rem',
      fontWeight: 'bold',
      backgroundColor: this.muiTheme.palette.primary.main,
      padding: '12px',
      border: 'none',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      display: 'flex',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: `${this.muiTheme.palette.primary.main}`
      },
      [`&.${tabUnstyledClasses.selected}`]: {
        backgroundColor: '#fff',
        color: this.muiTheme.palette.getContrastText('#fff')
      },
      [`&.${buttonUnstyledClasses.disabled}`]: {
        opacity: '0.5',
        cursor: 'not-allowed'
      }
    }
  }
}
